var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TabSwitch"},_vm._l((_vm.items),function(item){return _c('div',{key:item.value,staticClass:"TabSwitch__item",class:{'TabSwitch__item--active': _vm.value === item.value},on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }